export default "https://static.wetvinfo.com/tv/linux/static/media/guide_R.png";